var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wave-id-cell"},[_c('a',{staticClass:"edit-link",on:{"click":_vm.goToModule}},[_vm._v(_vm._s(_vm.module.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }